import * as React from "react";
import { useState } from "react";

import Box from "@mui/material/Box";
import { Formik, Field, Form, ErrorMessage } from "formik";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Button, Checkbox, TextField, FormHelperText } from "@mui/material";
import { ReportBugValidation } from "../../../../../validations/supportsFormsValidation";
import Typography from "@mui/material/Typography";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";
import { reportBugApi } from "../../../../../services/supportApi";

export default function ReportBug(props) {
  const [bug, setBug] = useState("");
  const [problemIn, setProblemIn] = useState([]);
  const [fileSelected, setFileSelected] = useState("");

  const handleSetProblemIn = (props, input) => {
    const { value, checked } = input;
    const Problems = problemIn;
    if (checked) {
      Problems.push(value);
    } else {
      const index = Problems.indexOf(value);
      Problems.splice(index, 1);
    }
    props.setFieldValue("problemIn", Problems);
    setProblemIn(Problems);
  };

  const initialValues = {
    bug: "",
    problemIn: [],
    file: "",
  };

  const reportBugToBack = async (data, props) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      const response = await reportBugApi(data)
      const resData = checkResponseData(response);

      if (resData["success"]) {
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        setBug("");
        setProblemIn([]);
        setFileSelected(false);
        // fileRef.current.value = null;
        props.setFieldValue("bug", "");
        props.setFieldValue("problemIn", []);
        props.setFieldValue("file", "");
      } else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      console.error(error);
    }
  };

  const onSubmit = (values, props) => {
    let newValues = {
      bug: values.bug,
      problemIn: values.problemIn,
      file: values.file,
    };
    reportBugToBack(newValues, props);
  };

  return (
    <Box
      sx={{
        m: 1,
        borderRadius: " 15px",
        p: 1,
        border: 2,
        borderColor: "secondary.main",
        backgroundColor: "#e5b7b74a",
      }}
    >
      <Formik
        initialValues={initialValues}
        validationSchema={ReportBugValidation}
        onSubmit={onSubmit}
      >
        {(props) => (
          <Form>
            <Typography>مشکل در بخش:</Typography>
            <FormControlLabel
              sx={{ ml: 2 }}
              value="site"
              control={
                <Checkbox
                  checked={problemIn.includes("site")}
                  onClick={(e) => {
                    handleSetProblemIn(props, e.target);
                  }}
                />
              }
              label="سایت"
              labelPlacement="start"
            />
            {/* <FormControlLabel
              sx={{ ml: 2 }}
              value="mobileApp"
              control={
                <Checkbox
                  checked={problemIn.includes("mobileApp")}
                  onClick={(e) => {
                    handleSetProblemIn(props, e.target);
                  }}
                />
              }
              label="برنامه موبایل"
              labelPlacement="start"
            />
            <FormControlLabel
              value="windowsApp"
              control={
                <Checkbox
                  checked={problemIn.includes("windowsApp")}
                  onClick={(e) => {
                    handleSetProblemIn(props, e.target);
                  }}
                />
              }
              label="برنامه ویندوز"
              labelPlacement="start"
            /> */}
            <FormHelperText
              sx={{ m: 0, p: 0, color: "#f96767", textAlign: "center" }}
            >
              <ErrorMessage name="problemIn" />
            </FormHelperText>
            <Field
              variant="filled"
              focused
              as={TextField}
              sx={{ pr: 5, my: 2 }}
              value={bug}
              type="text"
              multiline
              name="bug"
              label="توضیحات"
              rows={4}
              fullWidth
              placeholder="شرح مشکل"
              onChange={(event) => {
                props.setFieldValue("bug", event.target.value);
                setBug(event.target.value);
              }}
            // helperText={
            //   <FormHelperText
            //     sx={{ m: 0, p: 0, color: "#f96767", textAlign: "center" }}
            //   >
            //     <ErrorMessage name="bug" />
            //   </FormHelperText>
            // }
            />
            <FormHelperText
              sx={{ m: 0, p: 0, color: "#f96767", textAlign: "center" }}
            >
              <ErrorMessage name="bug" />
            </FormHelperText>
            <br />
            <Button
              type="submit"
              variant="contained"
              sx={{ m: 3 }}
              color="success"
            >
              ثبت مشکل
            </Button>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
